import { createSelectionListViewComponent } from 'factories/SelectionListView'
import { getSessionItem, updateSessionItem } from 'helpers/sessionStorage'
import { getStorageKey } from '.'

export default createSelectionListViewComponent({
  pageTitleLanguageKey: 'type',
  allowInfiniteLoader: () => false,
  allowSearch: () => false,
  getValue: () => getSessionItem(getStorageKey(), {}).item?.type,
  getOnChange: (self) => (each) =>
    updateSessionItem(getStorageKey(), {}, (draft) => {
      draft.item.type = each.id
      draft.item.itemsToCount = null
      draft.item.elapsedDays = null
      draft.item.minimumPrice = null
      draft.item.firstBarcode = null
      draft.item.lastBarcode = null
      draft.item.firstBinLocation = null
      draft.item.lastBinLocation = null
    }),
})()
